import { Box, Stack } from '@mui/material';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/mui';
import { useParams } from 'react-router';
import { ReadOnlyField } from '../../../../components/fields/ReadOnlyField.tsx';
import { AccountWithMagazines } from '../../../../types/account.ts';
import { getStatusLabel } from './utils.ts';

export const AccountShow = () => {
  const { organizationId } = useParams<{ organizationId: string }>();

  const {
    query: { data, isLoading },
  } = useShow<AccountWithMagazines>({
    meta: {
      organizationId,
    },
    resource: `organization/${organizationId}/accounts`,
    queryOptions: {
      select({ data }) {
        return {
          data: AccountWithMagazines.parse(data),
        };
      },
    },
  });

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack spacing={2}>
        <Box display="flex" gap={2}>
          <ReadOnlyField name="name" label="名前" sx={{ flex: 1 }}>
            {record?.name}
          </ReadOnlyField>
          <ReadOnlyField name="email" label="メールアドレス" sx={{ flex: 1 }}>
            {record?.email}
          </ReadOnlyField>
        </Box>
        <Box display="flex" gap={2}>
          <ReadOnlyField name="magazineOptions.nbl" label="NBLオプション" sx={{ flex: 1 }}>
            {record?.magazineOptions.nbl ? 'ON' : 'OFF'}
          </ReadOnlyField>
          <ReadOnlyField
            name="magazineOptions.shiryoban"
            label="資料版商事法務オプション"
            sx={{ flex: 1 }}
          >
            {record?.magazineOptions.nbl ? 'ON' : 'OFF'}
          </ReadOnlyField>
          <ReadOnlyField
            name="magazineOptions.junkan"
            label="旬刊商事法務オプション"
            sx={{ flex: 1 }}
          >
            {record?.magazineOptions.nbl ? 'ON' : 'OFF'}
          </ReadOnlyField>
        </Box>
        <Box display="flex" gap={2}>
          <ReadOnlyField sx={{ flex: 1 }}>{record?.isAdmin ? '管理者' : '一般'}</ReadOnlyField>
          <ReadOnlyField name="status" label="利用状況" sx={{ flex: 1 }}>
            {record ? getStatusLabel(record.status) : ''}
          </ReadOnlyField>
          <ReadOnlyField label="招待状況" sx={{ flex: 1 }}>
            {record?.isInvited ? '招待中' : '-'}
          </ReadOnlyField>
        </Box>
      </Stack>
    </Show>
  );
};
